/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";

export type GetOrganizationRemoteSessionClientSecurity = {
  sessionHeaderGramSession?: string | undefined;
  apikeyHeaderGramKey?: string | undefined;
};

export type GetOrganizationRemoteSessionClientRequest = {
  /**
   * The remote_session_client id.
   */
  id: string;
  /**
   * Session header
   */
  gramSession?: string | undefined;
  /**
   * API Key header
   */
  gramKey?: string | undefined;
};

/** @internal */
export type GetOrganizationRemoteSessionClientSecurity$Outbound = {
  "session_header_Gram-Session"?: string | undefined;
  "apikey_header_Gram-Key"?: string | undefined;
};

/** @internal */
export const GetOrganizationRemoteSessionClientSecurity$outboundSchema:
  z.ZodMiniType<
    GetOrganizationRemoteSessionClientSecurity$Outbound,
    GetOrganizationRemoteSessionClientSecurity
  > = z.pipe(
    z.object({
      sessionHeaderGramSession: z.optional(z.string()),
      apikeyHeaderGramKey: z.optional(z.string()),
    }),
    z.transform((v) => {
      return remap$(v, {
        sessionHeaderGramSession: "session_header_Gram-Session",
        apikeyHeaderGramKey: "apikey_header_Gram-Key",
      });
    }),
  );

export function getOrganizationRemoteSessionClientSecurityToJSON(
  getOrganizationRemoteSessionClientSecurity:
    GetOrganizationRemoteSessionClientSecurity,
): string {
  return JSON.stringify(
    GetOrganizationRemoteSessionClientSecurity$outboundSchema.parse(
      getOrganizationRemoteSessionClientSecurity,
    ),
  );
}

/** @internal */
export type GetOrganizationRemoteSessionClientRequest$Outbound = {
  id: string;
  "Gram-Session"?: string | undefined;
  "Gram-Key"?: string | undefined;
};

/** @internal */
export const GetOrganizationRemoteSessionClientRequest$outboundSchema:
  z.ZodMiniType<
    GetOrganizationRemoteSessionClientRequest$Outbound,
    GetOrganizationRemoteSessionClientRequest
  > = z.pipe(
    z.object({
      id: z.string(),
      gramSession: z.optional(z.string()),
      gramKey: z.optional(z.string()),
    }),
    z.transform((v) => {
      return remap$(v, {
        gramSession: "Gram-Session",
        gramKey: "Gram-Key",
      });
    }),
  );

export function getOrganizationRemoteSessionClientRequestToJSON(
  getOrganizationRemoteSessionClientRequest:
    GetOrganizationRemoteSessionClientRequest,
): string {
  return JSON.stringify(
    GetOrganizationRemoteSessionClientRequest$outboundSchema.parse(
      getOrganizationRemoteSessionClientRequest,
    ),
  );
}
